import { usePostPortfolioBuildingSavingsMutation } from "web_myplann/Api/Portfolio/Mutations/usePostPortfolioBuildingSavingsMutation";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import { BUILDING_SAVINGS_FORM_DEFAULT_VALUES } from "web_myplann/Portfolio/Forms/BuildingSavingsForm/buildingSavingsFormDefaults";
import { getBuildingSavingsFormSchema } from "web_myplann/Portfolio/Forms/BuildingSavingsForm/buildingSavingsFormSchema";
import { useCreatePortfolioForm } from "web_myplann/Portfolio/PortfolioShared/useCreatePortfolioForm";

export const useCreateBuildingSavingsForm = () => {
	const { t } = useResource();
	const { mutate, isPending } = usePostPortfolioBuildingSavingsMutation();

	const { form, onSubmit } = useCreatePortfolioForm({
		schema: getBuildingSavingsFormSchema(t),
		defaultValues: BUILDING_SAVINGS_FORM_DEFAULT_VALUES,
		mutate,
		successRoute: Routing.Portfolio.PortfolioAddBuildingSavingsSuccess.path(),
	});

	return { form, onSubmit, isPending };
};
